import { IModelObserver } from "./model-notifier/ah.mb.ui.model-observer";
import { INodeObject, NodeObject } from "./common/ah.mb.common.node-object";
import { LinkProperty } from "./ah.mb.model-utils";

// Todo: Allow observers to opt-in to certain events rather than everything

/**
 * Model change notifier
 */
export class ModelNotifier {

    observers: Array<IModelObserver>;

    /**
     * Ctor
     */
    constructor() {
        this.observers = new Array<IModelObserver>();
    }

    /**
     * Attaches an observer
     * @param observer
     */
    attach(observer: IModelObserver) {
        this.observers.push(observer);
    }

    /**
     * Detatches an observer
     * @param observer
     */
    detatch  (observer: IModelObserver)  {
        this.observers = this.observers.filter(p => !(p === observer));
    }

    /**
     * Notify observers of new node
     * @param node
     */
    notifyNodeCreated(node: NodeObject, initData: any) {
        this.observers.forEach(obs => {
            obs.nodeCreated(this, node, initData);
        });
    }

    /**
     * Notify observers of renamed node
     * @param pathAndName
     * @param newName
     */
    notifyNodeRenamed(pathAndName: string, newName: string) {
        this.observers.forEach(obs => {
            obs.nodeRenamed(this, pathAndName, newName);
        });

    }

    /**
     * Notify observers of node deletion
     * @param nodes
     */
    notifyNodesDeleted(nodes: Array<NodeObject>) {
        this.observers.forEach(obs => {
            obs.nodesDeleted(this, nodes);
        });

    }

    /**
     * Notify observers node paste
     * @param nodePathAndNames
     */
    notifyNodesPasted(targetPath: string, nodePathAndNames: Array<string>, isCut: boolean) {
        this.observers.forEach(obs => {
            obs.nodesPasted(this, targetPath, nodePathAndNames, isCut);
        });
    }

    /**
     * Notify observers of link creation
     * @param srcNode
     * @param destNode
     * @param commodity
     * @param units
     * @param properties
     */
    notifyLinkCreated(srcNode: string,
        destNode: string,
        commodity: string,
        units: string,
        properties: Array<LinkProperty>) {

        this.observers.forEach(obs => {
            obs.linkCreated(srcNode, destNode, commodity, units, properties);
        });
    }

    /**
     * Link deleted notification
     * @param srcNode
     * @param destNode
     */
    notifyLinkDeleted(srcNode: string, destNode: string)  {

        this.observers.forEach(obs => {
            obs.linkDeleted(srcNode, destNode);
        });
    }

    /**
* Notify observers of link creation
* @param srcNode
* @param destNode
* @param commodity
* @param units
* @param properties
*/
    notifyLinkEdited(srcNode: string,
        destNode: string,
        commodity: string,
        units: string,
        properties: Array<LinkProperty>) {

        this.observers.forEach(obs => {
            obs.linkEdited(srcNode, destNode, commodity, units, properties);
        });
    }

    notifyNodesGrouped(nodes: INodeObject[], group: string) {
        this.observers.forEach(obs => {
            obs.nodesGrouped(this, nodes, group);
        });
    }

    notifyNodesUngrouped(groupNodePathAndName: string): Promise<any> {

        var promises = new Array<Promise<any>>(); //

        this.observers.forEach(obs => {
            promises.push(obs.nodesUngrouped(this, groupNodePathAndName));
        });

        return $.when.apply($, promises);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/scripts/model-notifier.ts